import { memo, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import Button, { IButtonProps } from '../Button';

import { useMobileState } from '../Wizard/hooks';
import { useStyles } from './styles';

type IModifiedButtonProps = Omit<IButtonProps, 'label'> & {
  label?: ReactNode;
  mobileLabel?: ReactNode;
  isHidden?: boolean;
};

export interface INavigationButtonsProps {
  primaryButtonProps: IModifiedButtonProps;
  secondaryButtonProps?: IModifiedButtonProps;
  parentClass?: string;
}

const NavigationButtons: React.FC<INavigationButtonsProps> = ({
  primaryButtonProps,
  secondaryButtonProps,
  parentClass = '',
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { isMobileScreen } = useMobileState();
  return (
    <div className={`${classes.parentClass} ${parentClass}`}>
      {!secondaryButtonProps || secondaryButtonProps?.isHidden ? null : (
        <Button
          {...secondaryButtonProps}
          disabled={secondaryButtonProps.disabled || primaryButtonProps.isLoading}
          variant={isMobileScreen ? 'outlined' : 'text'}
          disableRipple={isMobileScreen ? false : true}
          label={secondaryButtonProps.label || t('common.back')}
        />
      )}
      {primaryButtonProps.isHidden ? null : (
        <Button
          {...primaryButtonProps}
          label={(isMobileScreen ? primaryButtonProps.mobileLabel : primaryButtonProps.label) || t('common.next')}
          hasEndArrow={isMobileScreen ? false : primaryButtonProps.hasEndArrow}
        />
      )}
    </div>
  );
};

export default memo(NavigationButtons);
